export default __webpack_public_path__ + "static/media/bg10.1d40343e.jpeg";